import { Link } from "react-router-dom";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="site-footer">
      <div className="container">
        <p>
          <strong>HS Library Hangout</strong> is an independently organized parent group. It is not sponsored,
          managed, approved, or endorsed by Oak Lawn Public Library. Library staff do not manage events,
          registrations, supervision, or questions for this group.
        </p>
        <ul className="footer-links">
          <li>
            <Link to="/non-affiliation">Library Non-Affiliation</Link>
          </li>
          <li>
            <Link to="/privacy">Privacy</Link>
          </li>
          <li>
            <Link to="/terms">Terms</Link>
          </li>
          <li>
            <Link to="/safety">Safety &amp; Conduct</Link>
          </li>
          <li>
            <Link to="/contact">Contact</Link>
          </li>
          <li>
            <Link to="/admin/login">Organizer Login</Link>
          </li>
        </ul>
        <p>&copy; {year} HS Library Hangout. hslibraryhangout.com</p>
      </div>
    </footer>
  );
}
